import { Box, useColorModeValue as mode } from "@chakra-ui/react";
export default function Separator() {
  return (
    <Box
      as="span"
      display="block"
      width="100%"
      height="1px"
      bg={mode("border.lightMode.light", "border.darkMode.light")}
    />
  );
}
